import { render, staticRenderFns } from "./EntityPage.vue?vue&type=template&id=6ac16a8c&scoped=true&"
import script from "./EntityPage.vue?vue&type=script&lang=ts&"
export * from "./EntityPage.vue?vue&type=script&lang=ts&"
import style0 from "./EntityPage.vue?vue&type=style&index=0&id=6ac16a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac16a8c",
  null
  
)

export default component.exports